import { Suspense, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DeleteModel from "../../../Components/DeleteModel";
import {
 deleteItem,
 fetchData,
 submitForm,
 toggleStatus,
} from "../../../utils/apiUtils";
import { PlusButton, SwitchToggle } from "../../../helper/ImageFormat";
import Breadcrumb from "../../../helper/Breadcrumb";
import AttributeTable from "./Table";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import { selectStyles } from "../../../utils/selectStyles";
import Select from "react-select";
const Attributes = () => {
 const [loading, setLoading] = useState(false);
 const [attributeData, setAttributeData] = useState([]);
 const [editingId, setEditingId] = useState(null);
 const navigator = useNavigate();
 const [isDeleting, setIsDeleting] = useState(false);
 const [btnloading, setBtnLoading] = useState(false);
 const [errors, setErrors] = useState({
  key: "",
  name: "",
  inputType: "",
  type: "",
  isDefault: false,
  showInCatalogue: false,
 });
 const [data, setData] = useState({
  key: "",
  name: "",
  inputType: "",
  type: "",
  isDefault: false,
  showInCatalogue: false,
  isActive: true,
 });

 const [deleteItemId, setDeleteItemId] = useState({});
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [modalOpen, setModalOpen] = useState(false);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [search, setSearch] = useState("");
 const handleEditClick = (data) => {
  setEditingId(data?.id);

  setData({
   key: data?.key,
   name: data?.name,
   inputType: data?.inputType || "",
   type: data?.type,
   isDefault: data?.isDefault,
   isActive: data?.isActive ?? true,
   showInCatalogue:
    data?.showInCatalogue === null ? false : data.showInCatalogue,
  });
  setModalOpen(true);
 };

 const totalPages = Math.ceil(totalCount / perPage);

 const toggleModal = () => {
  setModalOpen(!modalOpen);
  setEditingId(null);
  setErrors({
   name: "",
   key: "",
   inputType: "",
   type: "",
   isDefault: false,
   showInCatalogue: false,
  });
 };

 const handleAddAttValue = () => {
  setData({
   name: "",
   key: "",
   inputType: "",
   type: "",
   isDefault: false,
   showInCatalogue: false,
  });
  setEditingId("");
  setModalOpen(true);
 };

 const fetchAttribute = async (page = 1, searchQuery = "") => {
  const requestData = {
   perPage: perPage,
   pageNo: page,
   search: searchQuery,
  };
  await fetchData(
   "attribute-pagination",
   requestData,
   setAttributeData,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
 };

 useEffect(() => {
  const delay = search ? 500 : 0;
  const handler = setTimeout(() => {
   fetchAttribute(currentPage, search);
  }, delay);
  return () => clearTimeout(handler);
 }, [search, perPage]);

 const handleChange = (e) => {
  const { name, value, checked, type } = e.target;

  setData((prevState) => ({
   ...prevState,
   [name]: type === "checkbox" ? checked : value,
  }));

  setErrors({ ...errors, [name]: "" });
 };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setBtnLoading(true);
  // data.inputType = "MultipleSelect";
  try {
   await submitForm({
    data,
    url: "/attribute",
    editingId,
    validateFields: [
     { name: "name", message: "name is required" },
     { name: "key", message: "key is required" },
     { name: "type", message: "Type is required" },
    ],
    validationErrorsSetter: setErrors,
    onSuccess: () => fetchAttribute(),
    navigate: () => navigator("/attributes"),
    closeModal: () => setModalOpen(false),
   });
  } catch (error) {
   return error;
  } finally {
   setBtnLoading(false);
  }
 };

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("attribute", deleteItemId?.id, fetchAttribute);
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (item) => {
  const data = await toggleStatus("attribute-status", item?.id, fetchAttribute);
  if (Object.keys(data).length > 0) {
   setAttributeData((prevCurrencies) =>
    prevCurrencies.map((curr) =>
     curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const handleFilterToggle = async (item) => {
  const data = await toggleStatus(
   "attribute-filterstatus",
   item?.id,
   fetchAttribute
  );
  if (Object.keys(data).length > 0) {
   setAttributeData((prevdata) =>
    prevdata.map((curr) =>
     curr.id === item.id ? { ...curr, showInFilter: data?.showInFilter } : curr
    )
   );
  }
 };

 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchAttribute(page);
  }
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Attributes", path: "*" },
 ];

 const typeOptions = [
  { value: "Attribute", label: "Attribute" },
  { value: "Colour", label: "Colour" },
  { value: "Label", label: "Label" },
];

const inputTypeOptions = [
  { value: "TextField", label: "TextField" },
  { value: "MultipleSelect", label: "MultipleSelect" },
];

 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Attributes</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage} />

     <div style={{ display: "flex", gap: "20px" }}>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={handleAddAttValue} module={"Attributes"} />
     </div>
    </div>

    <AttributeTable
     loading={loading}
     attributeData={attributeData}
     currentPage={currentPage}
     perPage={perPage}
     handleDelete={handleDelete}
     handleEditClick={handleEditClick}
     handleStatusToggle={handleStatusToggle}
     totalCount={totalCount}
     totalPages={totalPages}
     handleFilterToggle={handleFilterToggle}
     handlePageClick={handlePageClick}
    />
   </div>
   {modalOpen && (
    <Modal
     isOpen={modalOpen}
     toggle={toggleModal}
     centered
     className="white-modal"
    >
     <ModalHeader toggle={toggleModal} className="close-currency">
      {editingId ? "Edit" : "Add"} Attribute
     </ModalHeader>
     <form onSubmit={handleSubmit}>
      <ModalBody className="currency">
       <div className="row">
       <div className="col-md-12 mb-3">
  <Select
    options={typeOptions}
    value={typeOptions.find(option => option.value === data?.type) || null}
    onChange={(selectedOption) => {
      setData((prev) => ({ ...prev, type: selectedOption?.value || "" }));
      setErrors((prev) => ({ ...prev, type: "" }));
    }}
    placeholder="Select Type"
    isClearable
    styles={selectStyles}
  />
  {errors.type && <small className="text-danger">{errors.type}</small>}
</div>

<div className="col-md-12 mb-3">
  <Select
    options={inputTypeOptions}
    value={inputTypeOptions.find(option => option.value === data?.inputType) || null}
    onChange={(selectedOption) => {
      setData((prev) => ({ ...prev, inputType: selectedOption?.value || "" }));
      setErrors((prev) => ({ ...prev, inputType: "" })); 
    }}
    placeholder="Select Field Type"
    isClearable
    styles={selectStyles}
  />
  {errors.inputType && <small className="text-danger">{errors.inputType}</small>}
</div>


        <div className="col-md-12 mb-3">
         <input
          type="text"
          className="form-control form-control-sm border border-dark"
          id="name"
          name="name"
          placeholder="Enter attribute name"
          value={data.name}
          onChange={handleChange}
         />
         {errors.name && <small className="text-danger">{errors.name}</small>}
        </div>

        <div className="col-md-12 mb-3">
         <input
          type="text"
          className="form-control form-control-sm border border-dark"
          id="key"
          name="key"
          placeholder="Enter attribute key"
          value={data.key}
          onChange={handleChange}
         />
         {errors.key && <small className="text-danger">{errors.key}</small>}
        </div>

        <div className="col-md-12 mb-3">
         <label className="dotted-option">
          <input
           type="checkbox"
           name="showInCatalogue"
           checked={data.showInCatalogue}
           onChange={(e) =>
            setData((prev) => ({
             ...prev,
             showInCatalogue: e.target.checked,
            }))
           }
          />

          <span className="radio-ui"></span>

          <span className="option-text">Show In Catalogue</span>
         </label>
        </div>

        <div className="col-md-12 p-2">
         <SwitchToggle
          checked={data.isActive}
          onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
         />
        </div>
       </div>
      </ModalBody>
      <ModalFooter>
       <Button type="submit" color="primary" disabled={btnloading}>
        {btnloading ? (
         <>
          Loading <i className="fas fa-spinner fa-spin me-2" />
         </>
        ) : editingId ? (
         "Update"
        ) : (
         "Add"
        )}
       </Button>
       <Button color="danger" onClick={toggleModal}>
        Cancel
       </Button>
      </ModalFooter>
     </form>
    </Modal>
   )}

   <Suspense fallback={<div>Loading...</div>}>
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="attribute"
     isDeleting={isDeleting}
    />
   </Suspense>
  </>
 );
};

export default Attributes;
